(() => {
  const initPromo = (root) => {
    if (root.dataset.psiPromoReady === 'true') return;

    const track = root.querySelector('.psi-search-promo__track');
    const slides = Array.from(root.querySelectorAll('.psi-search-promo__slide'));
    if (!track || slides.length < 2) return;

    root.dataset.psiPromoReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = null;

    const show = (nextIndex) => {
      index = nextIndex % slides.length;
      track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    };

    const stop = () => {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => show(index + 1), 5000);
    };

    show(0);
    start();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', start);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(start);
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-psi-search-promo]').forEach(initPromo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
